import spartaSingletonUtility from "utilities/global/sparta-singleton-utility/1.0.0/js/sparta-singleton-utility";
import HttpClient from "utilities/community/http-client/1.2.1/js/client";
import HTTP from "utilities/community/http-client/1.2.1/js/client";
import Http from "utilities/community/http-client/1.2.1/js/client";
import $http from "utilities/community/http-client/1.2.1/js/client";
import _ from "utilities/vendor/lodash/4.17.21/js/lodash.custom.min";
import Redux from "utilities/vendor/redux/3.6.0/js/index";
import middlewares from "utilities/community/spardux/4.0.1/js/middlewares";
import Diff from "utilities/community/spardux/4.0.1/js/diff";


















class Spardux {




  getState() {
    return this.store.getState()
  }





  get state() {
    return this.getState();
  }






  get actions() {
    return this._actions;
  }





  get dispatch() {
    return this.actions;
  }







  get(keypath, def = null) {
    return _.get(this.getState(), keypath, def)
  }




















  observe(subset, callback) {
    const keys = Object.keys(this._observables);
    if (!_.includes(keys, subset)) {
      this._observables[subset] = [];
    }
    this._observables[subset].push(callback);
    return this;
  }















  subscribe(callback, subset=[]) {
    const keys = Object.keys(this._subs);
    if (subset.length > 0) {
      for (const _subset of subset) {
        if (!_.includes(keys, _subset)) {
          this._subs[_subset] = [];
        }
        this._subs[_subset].push(callback)
      }
    }
    else {
      this._subs['*'].push(callback)
    }
    return this;
  }






  genUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }






  deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach((prop) => {
      if (o.hasOwnProperty(prop)
        && o[prop] !== null
        && (typeof o[prop] === 'object' || typeof o[prop] === 'function')
        && !Object.isFrozen(o[prop])) {
        this.freeze(o[prop]);
      }
    });
    return o;
  }







  deepCopy(data) {
    let node;
    if (Array.isArray(data)) {
      node = data.length > 0 ? data.slice(0) : [];
      node.forEach((e, i) => {
        if (
          (typeof e === 'object' && e !== {}) ||
          (Array.isArray(e) && e.length > 0)
        ) {
          node[i] = this.copy(e);
        }
      });
    } else if (data !== null && typeof data === 'object') {
      node = Object.assign({}, data);
      Object.keys(node).forEach((key) => {
        if (
          (typeof node[key] === 'object' && node[key] !== {}) ||
          (Array.isArray(node[key]) && node[key].length > 0)
        ) {
          node[key] = this.copy(node[key]);
        }
      });
    } else {
      node = data;
    }
    return node;
  }






  _observablesObserver() {
    this.store.subscribe(() => {
      const sNewState = this.getState();
      const sPrevState = this.prevState;
      const sDiff = new Diff(sPrevState, sNewState);
      const changes = sDiff.diff();
      const cKeys = Object.keys(changes);
      if (cKeys.length) {
        cKeys
          .filter(subset => this._observables.hasOwnProperty(subset) && sPrevState && sNewState.hasOwnProperty(subset))
          .map(subset => {
            const diff = new Diff(sPrevState[subset], sNewState[subset]);
            this._observables[subset]
              .map(callback => callback.call(this, sNewState[subset], diff.diffObject()))
          });
      }
    })
  }





  _subsObserver() {
    this.store.subscribe(() => {
      const sNewState = this.getState();
      const sPrevState = this.prevState;
      const sDiff = new Diff(sPrevState, sNewState);
      const changes = sDiff.diff();
      const cKeys = Object.keys(changes);
      if (cKeys.length) {
        const found = cKeys
          .filter(subset => this._subs.hasOwnProperty(subset) && sPrevState && sNewState.hasOwnProperty(subset))
          .map(subset => {
            this._subs[subset].map(callback => callback.call(this, sNewState, sDiff));
            return subset;
          });

        if (found.length === 0) {
          for (const callback of this._subs["*"]) {
            try {
              callback.call(this, sNewState, sDiff)
            } catch(e) {
              console.log('Spardux Observer error', callback, e)
            }
          }
        }
      }
    })
  }




































































































  compose(key, composer) {
    if (!_.isPlainObject(composer) || _.isEmpty(composer)) {
      throw new Error(`Spardux.compose Error: composer '${key}' must be an object`);
    }

    let initialState = _.get(composer, 'initialState') || _.get(composer, 'state');
    const compositions = _.get(composer, 'compositions') || _.get(composer, 'actions');
    const selectors = _.get(composer, 'selectors');

    if (_.isEmpty(initialState)) {
      initialState = {};

    }
    if (_.isEmpty(compositions)) {
      throw new Error(`Spardux.compose Error: 'actions' property is missing or empty in '${key}' composer`);
    }

    if (!_.isEmpty(selectors)) {
      this._setSelectors(key, selectors);
    }

    let reducerMap = {};
    let actions = {};
    let reducers = {};

    for (const k in compositions) {
      const composition = compositions[k];
      for (const p of ['action', 'reducer']) {
        if (!_.has(composition, p)) {
          throw new Error(`Spardux.compose Error: '${p}' property is missing in the composition: '${k}' of '${key}' composer`);
        }
      }
      const type = composition.type ? composition.type : `${key}_${k}`.toUpperCase();

      const kfn = (...args) => ({
        ...composition.action.call(this, ...args),
        type: type
      });
      actions = {...actions, [k]: kfn};

      if (composition.reducer instanceof ReducerSet) {
        reducers = composition.reducer.reducers
      } else {
        reducers = {
          [type]: composition.reducer
        };
      }
      reducerMap = {...reducerMap, ...reducers};
    }
    const reducer = this._typedReducer(key, reducerMap, initialState);
    this.combine(key, actions, reducer);
  }






  _setSelectors(key, selectors) {
    if (!this._selectors[key]) this._selectors[key] = [];
    for (const k of Object.keys(selectors)) {

      if (!_.isFunction(selectors[k])) {
        throw new Error(`Spardux Error: Composer selectors property must be a function: ${k}@${key}`);
      }
      const fnStr = selectors[k].toString();
      this._selectors[key].push({
        key,
        name: k,
        fn: selectors[k],
        subsets: this.extractSubsetFromString(fnStr)
      })
    }
  }







  extractSubsetFromString(str) {







    const regex = /this.state(?:\.|\[['"])(.*?)(?:['"]\])?\./g;
    let match = regex.exec(str);
    const subsets = [];
    while (match !== null) {
      subsets.push(match[1]);
      match = regex.exec(str);
    }
    return subsets;
  }















































  combine(namespace, actions = null, reducer = null) {
    if (actions) {
      const _actions = {};
      for (const k in actions) {
        _actions[k] = (...args) => this.store.dispatch(actions[k].call(this, ...args));
      }
      this._actions = {...this._actions, [namespace]: _actions};
    }
    if (reducer) {
      this.addReducers({[namespace]: reducer.bind(this)});
    }
  }






  ReducerSet(reducers) {
    return new ReducerSet(reducers);
  }









  addReducers(reducers) {
    this._reducers = {...this._reducers, ...reducers};
    this.store.replaceReducer(Redux.combineReducers(this._reducers));
  }






























  defineType(actionType) {
    return {
      TYPE: actionType,
      PENDING: `${actionType}_PENDING`,
      FULFILLED: `${actionType}_FULFILLED`,
      REJECTED: `${actionType}_REJECTED`,
      CANCELED: `${actionType}_CANCELED`,
    }
  }

  constructor() {
    this.store = null;
    this.prevState = null;
    this._reducers = {};
    this._actions = {};
    this._selectors = {};
    this.http = HttpClient;
    this.$http = this.http;
    this._createStore();


    this._observables = {};
    this._observablesObserver();

    this._subs = {};
    this._subs['*'] = [];
    this._subsObserver();



    const _makeAsyncState = (__pending__, __fulfilled__, __rejected__, __cancelled__) => ({
      __pending__,
      __fulfilled__,
      __rejected__,
      __cancelled__
    });


    this.DEFAULT_STATE = _makeAsyncState(null, null, null, null);
    this.PENDING_STATE = _makeAsyncState(true, false, false, false);
    this.FULFILLED_STATE = _makeAsyncState(false, true, false, false);
    this.REJECTED_STATE = _makeAsyncState(false, false, true, false);
    this.CANCELLED_STATE = _makeAsyncState(false, false, false, true);

    this.ASYNC_REDUCER = {
      PENDING: (state, action) => ({
        ...state,
        ...this.PENDING_STATE
      }),
      FULFILLED: (state, action) => ({
        ...state,
        ...this.FULFILLED_STATE,
        data: action.payload
      }),
      REJECTED: (state, action) => ({
        ...state,
        ...this.REJECTED_STATE,
        __reason__: action.payload
      }),
      CANCELLED: (state, action) => ({
        ...state,
        ...this.CANCELLED_STATE,
        __reason__: action.meta.CANCELLED
      }),
    }
  }





  _createStore() {

    const isLocalEnv = _.includes(['127.0.0.1', '0.0.0.0', 'localhost'], window.location.hostname);






    const devToolExt = window.__REDUX_DEVTOOLS_EXTENSION__ || window.devToolsExtension;
    const devtool = devToolExt && isLocalEnv ? devToolExt() : f => f;

    const mdw = Redux.applyMiddleware(
      middlewares.multiActions,
      middlewares.debounce(),
      middlewares.promiseMiddleware(),
      Redux.thunk,
      middlewares.prevState(this),
      middlewares.payloadDash
    );
    const r = Redux.combineReducers({});
    this.store = Redux.compose(mdw, devtool)(Redux.createStore)(r, {});
  }































  _typedReducer(key, reducerMap, initialState = {}) {
    const flattened = this._typedReducerIterator(reducerMap);
    return (state = initialState, action) => {
      const subset = key;
      const reducer = flattened[action.type];
      let newState = reducer ? reducer(state, action) : state

      if (this._selectors[key]) {
        for (const g of this._selectors[key]) {
          newState[g.name] = g.fn.call(this, newState);
        }
      }
      return newState;
    }
  }

  _typedReducerIterator(reducers, initial = {}, prefix = []) {
    const reducerTypes = Object.keys(reducers || {});
    return reducerTypes.reduce((acc, type) => {
      const reducer = reducers[type];
      return typeof(reducer) === 'function'
        ? {...acc, [this._typedReducerMakeType(prefix, type)]: reducer}
        : this._typedReducerIterator(reducer, acc, [this._typedReducerMakeType(prefix, type)])
    }, initial)
  }

  _typedReducerMakeType(prefix, type) {
    const typeDelimiter = '_';
    return prefix.concat(type).join(typeDelimiter);
  }





  diff() {
    return new Diff(this.prevState, this.getState())
  }





  defineActionType(action_type) {
    console.warn('SPARDUX Warn: `defineActionType` is deprecated. Use the `Composer` method');
    return this.defineType(action_type);
  }












  sub(callback, subset = [], context = this) {
    this.store.subscribe(() => {
      const newState = this.getState();
      const diff = new Diff(this.prevState, newState);
      const changes = diff.diff();
      const cKeys = Object.keys(changes);
      const hasChanges = cKeys.length > 0
        ? (subset.length > 0 ? subset.some(r => cKeys.indexOf(r) >= 0) : true)
        : false;
      if (hasChanges) {
        return callback.call(context, newState, this.prevState, diff);
      }
    })
  }









  freeze(o) {
    return this.deepFreeze(o);
  }








  copy(data) {
    return this.deepCopy(data);
  }
}

class ReducerSet {
  constructor(reducers) {
    this.reducers = reducers;
  }
}

const spardux = spartaSingletonUtility('Spardux', Spardux);
export default spardux;




